import React from 'react';
import clsx from 'clsx';
import styles from './PageHeader.css';
import HeaderLeft from './PageHeaderLeft';
import HeaderRight from './PageHeaderRight';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    children: React.ReactNode;
}

const PageHeader = ({ children, className, ...others }: Props) => {
    return (
        <div className={clsx(styles.pageHeaderContainer, className)} {...others}>
            {children}
        </div>
    );
};

PageHeader.Left = HeaderLeft;
PageHeader.Right = HeaderRight;

export default PageHeader;
